import type {EventId} from '@cohort/shared/schema/apps';
import {getUserEventSpec} from '@cohort/shared/schema/apps';
import type {DataType} from '@cohort/shared/schema/common/rules/dataTypes';
import {match} from 'ts-pattern';
import {z} from 'zod';

type UserEventPropertyOption = {
  name: string;
  dataType: DataType;
};

const eventDateOption: UserEventPropertyOption = {
  name: 'eventDate',
  dataType: 'date',
} as const;

export function getUserEventPropertyOptions(eventId: EventId): UserEventPropertyOption[] {
  const eventStruct = getUserEventSpec(eventId);
  const propertiesSchema = eventStruct.propertiesSchema;
  const options = [eventDateOption];
  for (const [name, schema] of Object.entries(propertiesSchema.shape)) {
    const dataType = getDataTypeFromSchema(schema);
    if (dataType !== undefined) {
      options.push({
        name,
        dataType,
      });
    }
  }
  return options;
}

function getDataTypeFromSchema(schema: z.ZodTypeAny): DataType | undefined {
  const dataType = match(schema)
    .when(
      schema => schema instanceof z.ZodString,
      (): DataType => 'string'
    )
    .when(
      schema => schema instanceof z.ZodArray && schema.element instanceof z.ZodString,
      (): DataType => 'string_list'
    )
    .when(
      schema => schema instanceof z.ZodNumber,
      (): DataType => 'number'
    )
    .when(
      schema => schema instanceof z.ZodBoolean,
      (): DataType => 'boolean'
    )
    .when(
      schema => schema instanceof z.ZodDate,
      (): DataType => 'date'
    )
    .otherwise(() => undefined);
  return dataType;
}
